// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"f0506915","236":"60b0dcec","407":"2ac922fd","421":"902393c7","925":"b41ba148"}[chunkId] + ".chunk.css";
};